// variant-picker-product.js

var addingToCart = false

// ---- NUEVO: actualización de precio al cambiar de variante ----

function formatMoney(cents){
  if(cents === undefined || cents === null || cents === "") return ""
  const amount = Math.round(Number(cents) / 100)
  return "$" + amount.toLocaleString("es-CO")
}

// Actualiza el precio "local" que se muestra dentro del drawer (Top/Bottom/Single)
function updateLocalPrice(optionSelect, price, comparePrice){

  if(!optionSelect) return

  const priceEl = optionSelect.querySelector(".variant-price-display")
  if(!priceEl) return

  const hasDiscount = comparePrice && Number(comparePrice) > Number(price)

  priceEl.innerHTML = hasDiscount
    ? `<s>${formatMoney(comparePrice)}</s> ${formatMoney(price)}`
    : formatMoney(price)

}

// Devuelve el precio "efectivo" de un option-select: el de la talla
// seleccionada, o el precio por defecto si no hay ninguna seleccionada
function getEffectivePrice(optionSelect){

  const selectedBtn = optionSelect.querySelector(".size-button.selected")

  if(selectedBtn){
    return {
      price: selectedBtn.dataset.price,
      compare: selectedBtn.dataset.comparePrice
    }
  }

  const priceEl = optionSelect.querySelector(".variant-price-display")

  return {
    price: priceEl ? priceEl.dataset.defaultPrice : undefined,
    compare: priceEl ? priceEl.dataset.defaultComparePrice : undefined
  }

}

// Actualiza el precio "real" que se ve en la página del producto
// (fuera del drawer), tanto para producto simple como para sets (Top+Bottom)
function updateMainPagePrice(price, comparePrice){

  const priceTemplate = document.querySelector(".price-template")
  if(!priceTemplate) return

  const priceWrap = priceTemplate.querySelector(".price")
  const regularEl = priceTemplate.querySelector(".price__regular .price-item--regular")
  const saleOldEl = priceTemplate.querySelector(".price__sale s.price-item--regular")
  const saleCurrentEl = priceTemplate.querySelector(".price__sale .price-item--sale")

  const hasDiscount = comparePrice && Number(comparePrice) > Number(price)

  if(priceWrap) priceWrap.classList.toggle("price--on-sale", !!hasDiscount)

  if(regularEl) regularEl.textContent = formatMoney(price)
  if(saleCurrentEl) saleCurrentEl.textContent = formatMoney(price)
  if(saleOldEl) saleOldEl.textContent = hasDiscount ? formatMoney(comparePrice) : ""

}

// ---- FIN NUEVO ----

document.addEventListener("click", async function(e){

const sizeBtn = e.target.closest(".size-button")

if(sizeBtn){

  // bloquear scripts del theme
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
  

  const container = sizeBtn.closest(".product-options")
  const group = sizeBtn.closest(".btn-options")
  if(!container || !group) return

    const buttons = group.querySelectorAll(".size-button")

    const variantId = sizeBtn.dataset.variantId
    const type = sizeBtn.dataset.type
    const size = sizeBtn.dataset.size

    // TOGGLE
    if(sizeBtn.classList.contains("selected")){

      sizeBtn.classList.remove("selected")

      if(type === "top"){
        const el = container.querySelector(".selected-size-top")
        if(el) el.textContent = ""
      }

      if(type === "bottom"){
        const el = container.querySelector(".selected-size-bottom")
        if(el) el.textContent = ""
      }

      if(type === "single"){
        const el = container.querySelector(".selected-size")
        if(el) el.textContent = ""
      }

    }else{

      buttons.forEach(b => b.classList.remove("selected"))
      sizeBtn.classList.add("selected")

      if(type === "top"){
        const el = container.querySelector(".selected-size-top")
        if(el) el.textContent = size
      }

      if(type === "bottom"){
        const el = container.querySelector(".selected-size-bottom")
        if(el) el.textContent = size
      }

      if(type === "single"){
        const el = container.querySelector(".selected-size")
        if(el) el.textContent = size
     }

    }

    // NUEVO: recalcular y pintar el precio según la talla seleccionada
    const optionSelect = sizeBtn.closest(".option-select") || container
    const effective = getEffectivePrice(optionSelect)

    updateLocalPrice(optionSelect, effective.price, effective.compare)

    if(type === "single"){

      // producto de una sola opción: el precio mostrado es el de esta talla
      updateMainPagePrice(effective.price, effective.compare)

    }else{

      // producto tipo set (Top + Bottom): el precio real es la suma de
      // lo seleccionado (o el precio por defecto) en cada bloque
      const allOptionSelects = container.querySelectorAll(".option-select")
      let totalPrice = 0
      let totalCompare = 0

      allOptionSelects.forEach(os => {
        const eff = getEffectivePrice(os)
        totalPrice += Number(eff.price || 0)
        totalCompare += Number(eff.compare || eff.price || 0)
      })

      updateMainPagePrice(totalPrice, totalCompare)

    }

    const addBtn = container.querySelector(".add-to-cart-btn")
    const selected = container.querySelectorAll(".size-button.selected")

    if(addBtn){

      if(selected.length > 0){
        addBtn.disabled = false
        addBtn.textContent = `Agregar a la bolsa (${selected.length})`
      }else{
        addBtn.disabled = true
        addBtn.textContent = "Seleccionar talla"
      }

    }

    return
  }

  async function updateCartIcon(){

    try{

      const res = await fetch("/cart.js")
      const cart = await res.json()

      const bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble")
      const icon = document.querySelector("#cart-icon-bubble")

      if(!icon) return

      if(cart.item_count > 0){

        if(!bubble){
          const div = document.createElement("div")
          div.className = "cart-count-bubble"
          div.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`
          icon.appendChild(div)
        }else{
          const span = bubble.querySelector("span")
          if(span) span.textContent = cart.item_count
        }

      }else{
        if(bubble) bubble.remove()
      }

    }catch(e){
      console.error("Cart icon update error", e)
    }

  }

  const addBtn = e.target.closest(".add-to-cart-btn")
  if(!addBtn) return

  if(addBtn.classList.contains("loading")) return
  if(addingToCart) return

  const container = addBtn.closest(".product-options")
  
  // NUEVO: Detectar si es producto sin variantes (Default Title)
  const hasVariantSelector = container.querySelector(".size-button") !== null
  
  let items = []

  if(hasVariantSelector){
    // Producto CON variantes - comportamiento original
    const selectedVariants = container.querySelectorAll(".size-button.selected")
    items = [...selectedVariants].map(btn => ({
      id: btn.dataset.variantId || btn.dataset.variant,
      quantity: 1
    }))
  } else {
    // Producto SIN variantes (Default Title) - usar variant-id del botón
    const variantId = addBtn.dataset.variantId
    if(variantId){
      items = [{
        id: variantId,
        quantity: 1
      }]
    }
  }

  if(!items.length) return

  try{

    addingToCart = true

    addBtn.classList.add("loading")
    addBtn.disabled = true
    
    // NUEVO: Cambiar texto del botón mientras carga
    const originalText = addBtn.textContent
    addBtn.textContent = "Agregando..."

    const response = await fetch("/cart/add.js",{
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body: JSON.stringify({ items })
    })

    if(!response.ok) throw new Error("Cart error")

    const data = await response.json()

    await updateCartIcon()

    if (typeof openAddedDrawer === "function") {
      openAddedDrawer(data)
    }
    
  }catch(err){

    console.error("Add to cart error:", err)
    alert("Error al agregar al carrito. Por favor intenta de nuevo.")

  }finally{

    addingToCart = false
    addBtn.classList.remove("loading")
    
    // NUEVO: Restaurar estado del botón según el tipo de producto
    if(hasVariantSelector){
      const selected = container.querySelectorAll(".size-button.selected")
      if(selected.length > 0){
        addBtn.disabled = false
        addBtn.textContent = `Agregar a la bolsa (${selected.length})`
      }else{
        addBtn.disabled = true
        addBtn.textContent = "Seleccionar talla"
      }
    } else {
      // Para productos sin variantes, mantener habilitado
      addBtn.disabled = false
      addBtn.textContent = "Agregar al carrito"
    }

  }

}, true)